import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/auth/pre-login/login.component';
import { LoginsComponent } from './components/auth/logins/logins.component';
import { OtpVerificationComponent } from './components/auth/otp-verification/otp-verification.component';
import { ForgotpasswordComponent } from './components/auth/forgotpassword/forgotpassword.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { VerifypasswordComponent } from './components/auth/verifypassword/verifypassword.component';
import { OrderListComponent } from './components/admin/order-list/order-list.component';
import { AddOrderComponent } from './components/admin/add-order/add-order.component';
import { MultipleAddOrderComponent } from './components/admin/multiple-add-order/multiple-add-order.component';
import { WarehouseListComponent } from './components/admin/warehouse-list/warehouse-list.component';
import { WarehouseAddComponent } from './components/admin/warehouse-add/warehouse-add.component';
import { DriverListingComponent } from './components/admin/driver-listing/driver-listing.component';
import { AddDriverListingComponent } from './components/admin/add-driver-listing/add-driver-listing.component';
import { SendNotificationComponent } from './components/admin/send-notification/send-notification.component';
import { AddressListingComponent } from './components/admin/address-listing/address-listing.component';
import { AddAddressListingComponent } from './components/admin/add-address-listing/add-address-listing.component';
import { CompaniesListingComponent } from './components/admin/companies-listing/companies-listing.component';
import { ProfileComponent } from './components/admin/profile/profile.component';
import { TicketListingComponent } from './components/admin/ticket-listing/ticket-listing.component';
import { TicketDetailsComponent } from './components/admin/ticket-details/ticket-details.component';
import { SettingsComponent } from './components/admin/settings/settings.component';
import { ArchiveOrderComponent } from './components/admin/archive-order/archive-order.component';
import { LocateDriverComponent } from './components/admin/locate-driver/locate-driver.component';
import { DriverDetailComponent } from './components/admin/driver-detail/driver-detail.component';
import { CreateTicketComponent } from './components/admin/create-ticket/create-ticket.component';
import { OrderDetailComponent } from './components/admin/order-detail/order-detail.component';
import { BetaFeedbackComponent } from './components/admin/beta-feedback/beta-feedback.component';
import { FrontGuard } from './shared/front.guard';
import { AuthGuard } from './shared/auth.guard';
import { AnalyticsDashboardComponent } from './components/admin/analytics/analytics-dashboard.component';
import { DriverOrderListComponent } from './components/admin/driver-order-list/driver-order-list.component';
import { OrderDataResolver } from './resolvers/order-data.resolver';
import { ReceivingOrdersListingComponent } from './components/receiving-admin/receiving-orders-listing/receiving-orders-listing.component';
import { ReceivingOrderDetailComponent } from './components/receiving-admin/receiving-order-detail/receiving-order-detail.component';
import { DeactivateGuard } from './shared/deactivate.guard';
import { UpdatePlanComponent } from './components/update-plan/update-plan.component';
import { DispatchSheetComponent } from './components/admin/dispatch-sheet/dispatch-sheet.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    title: 'Pre Login',
    canActivate: [FrontGuard],
  },
  {
    path: 'login',
    component: LoginsComponent,
    title: 'Login',
    canActivate: [FrontGuard],
  },
  {
    path: 'otp-verification',
    component: OtpVerificationComponent,
    title: 'OTP Verification',
    canActivate: [FrontGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotpasswordComponent,
    title: 'Forgot Password',
    canActivate: [FrontGuard],
  },
  {
    path: 'verify-password',
    component: VerifypasswordComponent,
    title: 'Verify Password',
    canActivate: [FrontGuard],
  },
  {
    path: 'admin',
    title: 'Admin',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'analytics',
        component: AnalyticsDashboardComponent,
        title: 'Analytics',
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard',
        canActivate: [AuthGuard],
      },
      {
        path: 'orders',
        component: OrderListComponent,
        title: 'Orders',
        canActivate: [AuthGuard],
      },
      {
        path: 'orders/add',
        component: AddOrderComponent,
        title: 'Add Order',
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuard],
      },
      {
        path: 'orders/edit/:id',
        component: AddOrderComponent,
        title: 'Add Order',
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuard],
      },
      {
        path: 'orders/order-detail/:id',
        component: OrderDetailComponent,
        title: 'Order Details',
        canActivate: [AuthGuard],
      },
      {
        path: 'bulk-order',
        component: MultipleAddOrderComponent,
        title: 'Add Multiple Orders',
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuard],
      },
      {
        path: 'warehouse',
        component: WarehouseListComponent,
        title: 'Warehouse',
        canActivate: [AuthGuard],
      },
      {
        path: 'warehouse/add',
        component: WarehouseAddComponent,
        title: 'Add Warehouse',
        canActivate: [AuthGuard],
      },
      {
        path: 'warehouse/edit/:id',
        component: WarehouseAddComponent,
        title: 'Add Warehouse',
        canActivate: [AuthGuard],
      },
      {
        path: 'driver',
        component: DriverListingComponent,
        title: 'Driver Listing',
      },
      {
        path: 'driver/add',
        component: AddDriverListingComponent,
        title: 'Add Driver Listing',
      },
      {
        path: 'driver/edit/:id',
        component: AddDriverListingComponent,
        title: 'Add Driver Listing',
      },
      {
        path: 'driver/detail/:id',
        component: DriverDetailComponent,
        title: 'Driver Details',
      },
      {
        path: 'send-notification',
        component: SendNotificationComponent,
        title: 'Send Notification',
      },
      {
        path: 'address',
        component: AddressListingComponent,
        title: 'Address Listing',
      },
      {
        path: 'address/add',
        component: AddAddressListingComponent,
        title: 'Add Address Listing',
      },
      {
        path: 'address/edit',
        component: AddAddressListingComponent,
        title: 'Add Address Listing',
      },
      {
        path: 'companies',
        component: CompaniesListingComponent,
        title: 'Compaines Listing',
      },
      {
        path: 'ticket',
        component: TicketListingComponent,
        title: 'Tickets Listing',
      },
      {
        path: 'ticket/detail/:id',
        component: TicketDetailsComponent,
        title: 'Tickets Listing',
      },
      {
        path: 'ticket/create-ticket',
        component: CreateTicketComponent,
        title: 'Create Ticket',
      },
      {
        path: 'profile',
        component: ProfileComponent,
        title: 'Profile',
      },
       {
        path: 'update-plans/:id',
        component: UpdatePlanComponent,
        title: 'Update Plans',
      },
      {
        path: 'archive-orders',
        component: ArchiveOrderComponent,
        title: 'Archive Orders',
      },
      {
        path: 'setting',
        component: SettingsComponent,
        title: 'Settings',
      },
      {
        path: 'locate-driver',
        component: LocateDriverComponent,
        title: 'Locate Driver',
      },
      {
        path: 'beta-feedback',
        component: BetaFeedbackComponent,
        title: 'Beta Feedback',
      },
      {
        path: 'dispatch-sheet',
        component: DispatchSheetComponent,
        title: 'Open Sheet',
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuard],
      },
      {
        path: 'driver/detail/orders/:id',
        component: DriverOrderListComponent,
        title: '',
      },
    ],
  },
  {
    path: 'receiving-admin',
    title: 'Receiving Admin',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'orders',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        redirectTo: 'orders',
        pathMatch: 'full'
      },
      {
        path: 'orders',
        component: ReceivingOrdersListingComponent,
        title: 'Receiving Orders',
        canActivate: [AuthGuard],
      },
      {
        path: 'ticket',
        component: TicketListingComponent,
        title: 'Tickets Listing',
      },
      {
        path: 'setting',
        component: SettingsComponent,
        title: 'Settings',
      },
      {
        path: 'locate-driver',
        component: LocateDriverComponent,
        title: 'Locate Driver',
      },
      {
        path: 'orders/order-detail/:id',
        component: ReceivingOrderDetailComponent,
        title: 'Receiving Order Detail',
        canActivate: [AuthGuard],
      },
      {
        path: 'ticket/create-ticket',
        component: CreateTicketComponent,
        title: 'Create Ticket',
      },
      {
        path: 'beta-feedback',
        component: BetaFeedbackComponent,
        title: 'Beta Feedback',
      },
      {
        path: 'ticket/detail/:id',
        component: TicketDetailsComponent,
        title: 'Ticket Details',
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
